<script lang="ts">
    export let label:string = '';
    export let selected:boolean = false;
    export let handleClick = () => {};
    export let icon:IconTypes = 'none';
    export let tabid:string = '';
    export let largeLabel:boolean = false;
    export let tabStyleUnderlined:boolean = false;


    import Icon from "./icons.svelte";
    import type {IconTypes} from "./icons.svelte";

    let role = 'tab';
    if (tabid === '') {
        role = 'button';
    }
</script>

<button role={role} class:selected="{selected}" class:underlined="{tabStyleUnderlined}" on:click={handleClick} id={tabid}>
    <Icon icon={icon} />
    <p class="label" class:large={largeLabel}>{label}</p>
</button>

<style>
    button {
        border: none;
        color: var(--text);
        background: none;
        width: 100%;
        /* border-bottom: var(--background-offset) 2px solid; */
        transition: 0.3s;
        padding: 1rem 0.5rem;
        margin: 0;
        border-radius: 0;
        /* border-radius: 4px 4px 0 0; */
    }

    button:focus-visible {
        outline: var(--text) 2px solid;
        animation: focus_color 0.6s ease-in-out 0s infinite alternate
    }

    button:hover {
        background: var(--background-offset);
    }

    button.selected {
        /* border-bottom: var(--text) 2px solid; */
        background-color: var(--background-offset);
    }

    button.underlined {
        border-bottom: var(--background-offset) 2px solid;
        background-color: var(--background); 
    }
    button.underlined:hover {
        border-bottom: var(--text) 2px solid;
        background-color: var(--background-offset); 
    }
    button.underlined.selected {
        border-bottom: var(--text) 2px solid;
        /* background-color: var(--background);  */
    }

    p {
        margin: 0.5rem 0 0 0;
    }

    .label {
        font-size: smaller;
    }
    .label.large {
        font-size: unset;
    }

    @keyframes focus_color{ from { outline-color: var(--text); } to { outline-color: var(--background-offset); }  }

    @media (max-width: 960px) {
        button {
            margin: 0;
            padding: 0.5rem;
        }
    }

</style>